import { get, post, put, deletes } from './http'
let api = null
let api1
if (process.env.NODE_ENV === 'development') {
    
    // api = 'https://website.g0356.cn/gateway/api/v1';
    // api1 = 'https://website.g0356.cn';
    api = 'https://www.jcdfkj.com/gateway/api/v1';
    api1 = 'https://www.jcdfkj.com';
    // api = 'http://124.164.240.236:8900/gateway/api/v1';//开发环境
    // api1 = 'http://192.168.8.93:8900';//韩泽鑫
    // api =  api1 + '/gateway/api/v1';//韩泽鑫
    // api = 'http://192.168.8.58:9111/gateway/api/v1';//开发环境
    // api = 'http://192.168.8.42:8900/gateway/api/v1';//范巍
    // api = 'http://192.168.8.93:8900/gateway/api/v1';//韩泽鑫
    // api = 'http://192.168.8.107:9111/gateway/api/v1';//开发环境
} else if (process.env.NODE_ENV === 'production') {
    // api = 'http://127.0.0.1';//生产环境
    api = 'https://www.jcdfkj.com/gateway/api/v1';
    api1 = 'https://www.jcdfkj.com';
    // api = 'https://website.g0356.cn/gateway/api/v1';
    // api1 = 'https://website..cn';
    // api1 = 'https://website.g0356.cn';
}


// 服务领域标题
export const queryService = (data = {}) => post(api, data)

// IDC服务标题内容
export const idctitle = (data = {}) => post(api, data)
// 服务器租赁
export const queryIdcDetail = (data = {}) => post(api, data)
// 可用产品
export const queryProduct = (data = {}) => post(api, data)
// 证书类型
export const queryCert = (data = {}) => post(api, data)

// 访问首页增加浏览量服务
// export const viewsadd = (params = {}) => get(`http://192.168.8.42:8900/views/add`)
export const viewsadd = (params = {}) => get(api1+'/views/add')

// 设计类型列表获取
export const queryDesign = (data = {}) => post(api, data)

// 设计列表获取
export const queryDesignDetail = (data = {}) => post(api, data)

// 设计详情获取
export const cowDesignDetailGetInfo = (data = {}) => post(api, data)

// 查询弱电工程
export const queryWeakEngineer = (data = {}) => post(api, data)
// 弱电详情
export const queryWeakEngineerDetail = (data = {}) => post(api, data)

// 查询集成系统
export const queryIsr = (data = {}) => post(api, data)
// 系统集成详情
export const queryIsrDetail = (data = {}) => post(api, data)

// 查询运维服务
export const queryOperation = (data = {}) => post(api, data)
// 运维详情
export const queryOperationDetail = (data = {}) => post(api, data)

// 查询网站统计
export const queryCount = (data = {}) => post(api, data)

// 查询新闻咨询
export const cowNewsMainNewsList = (data = {}) => post(api, data)
// 新闻动态
// export const xwactive = (data = {}) => post(api, data)

//新闻左侧
// export const xinwenlift = (data = {}) => post(api, data)

// 新闻类型列表
export const cowNewTypeList = (data = {}) => post(api, data)

// 新闻类型详情获取
export const cowNewTypeGetInfo = (data = {}) => post(api, data)

// 新闻列表不带Img、content获取
export const cowNewsList = (data = {}) => post(api, data)

// 查询新闻咨询详情
export const queryNews = (data = {}) => post(api, data)

// 查询设计
// export const sheji = (data = {}) => post(api, data)

// 定制开发
export const queryServiceDetail = (data = {}) => post(api, data)

// 模板建站
export const temlplates = (data = {}) => post(api, data)

// 返回模板类型列表信息
export const sysDictDataList = (data = {}) => post(api, data)

// 业务费用
export const queryBussiness = (data = {}) => post(api, data)

// 公司简介
export const queryCompany = (data = {}) => post(api, data)

// 招纳贤士
export const queryJob = (data = {}) => post(api, data)

// 企业历程
export const queryEnterpriseHistory = (data = {}) => post(api, data)

// 人力资源图标标题
export const cowHumanResourceList = (data = {}) => post(api, data)

// 招贤纳士轮播图
export const cowHumanResourceGetInfo = (data = {}) => post(api, data)

// 获取图形验证码
export const getImageCode = (data = {}) => post(api, data)

// 获取短信验证码
export const sendMessage = (data = {}) => post(api, data)

// 账号注册
export const userRegister = (data = {}) => post(api, data)

// 账号登录
export const userLogin = (data = {}) => post(api, data)

// 重置密码-手机验证
export const verifyPhone = (data = {}) => post(api, data)

// 重置密码
export const forgotPassword = (data = {}) => post(api, data)

// 添加留言
export const addNote = (data = {}) => post(api, data)

// 账号设置
export const updateUser = (data = {}) => post(api, data)

// 报价咨询
export const addConsult = (data = {}) => post(api, data)

// 技术咨询
export const addTechnical = (data = {}) => post(api, data)

// 报价咨询记录
export const QueryConsult = (data = {}) => post(api, data)

// 技术咨询记录
export const queryTechnical = (data = {}) => post(api, data)

// 视频管理
export const getCowVideo = (data = {}) => post(api, data)

// 合作伙伴文本获取
export const cowCooperativePartnerGetInfo = (data = {}) => post(api, data)

// 合作伙伴列表查询
export const cowCooperativePartnerDetailList = (data = {}) => post(api, data)

// 友情链接
export const cowContactList = (data = {}) => post(api, data)

// 微信号和公众号
export const queryImgList = (data = {}) => post(api, data)

// 获取地区列表通过父id
export const cowAreaList = (data = {}) => post(api, data)

// 用户详情
export const selectUserInfoById = (data = {}) => post(api, data)

// 忘记密码
// export const forgotPassword = (data = {}) => post(api, data)

// 重置密码
export const resetPwd = (data = {}) => post(api, data)

//更换手机号
export const resetPhoneNumber = (data = {}) => post(api, data)

// 查询服务凭租价格表
export const cowLeasedPriceGetInfo = (data = {}) => post(api, data)

// 查询模板
export const queryTemplate = (data = {}) => post(api, data)

// 应聘岗位集合
export const selectJobArray = (data = {}) => post(api, data)

// 投递简历
export const addCowResume = (data = {}) => post(api, data)

// IDC服务
export const queryIdc = (data = {}) => post(api, data)

// IDC服务详情
export const IdcqueryIdcDetail = (data = {}) => post(api, data)

// 招聘信息详情
export const queryCowJobById = (data = {}) => post(api, data)

// 增加模板浏览次数
export const updateTemplate = (data = {}) => post(api, data)

// 微信登录
// export const wechartlogin = (data = {}) => post(`https://website.g0356.cn/wxLogin`, data)
export const wechartlogin = (data = {}) => post(`https://www.jcdfkj.com/wxLogin`, data)

// 动态获取产品价格
export const cowLeasedPriceCount = (data = {}) => post(api, data)

// 著作统计
export const cowCopyrightCount = (data = {}) => post(api, data)

//域名热度
export const cowDomainSuffixList = (data = {}) => post(api, data)

//域名注册查询
export const domainNameQuery = (data = {}) => post(api, data)

//每日海报
export const queryLatestPoster = (data = {}) => post(api, data)

// 海报下载
export const viewdown = (data = {}) => post(api1+'/upload/downloadFiles', data)

//微信手机号绑定
export const userBinding = (data = {}) => post(api, data)

//手机号登录
export const phoneNumberLogin = (data = {}) => post(api, data) 

// 微博登录
export const vbologin = (data = {}) => post(api1+'/gateway/api/wb/callBack', data)

// QQ登录
export const qqlogin = (data = {}) => post(api1+'/gateway/api/qq/callBack', data)

//短信价格
export const SMS_PriceList = (data = {}) => post(api, data) 

//每日海报列表
export const queryCowDailyProster = (data = {}) => post(api, data) 

// 物联网产品特性
export const selectCowIOTList = (data = {}) => post(api, data) 

// 物联网获取详情
export const getCowIOTDetail = (data = {}) => post(api, data) 

// 咨询详情
export const queryCowConsultationDetails = (data = {}) => post(api, data) 

//新增咨询详情对话
export const addCowConsultationDetails = (data = {}) => post(api, data) 

//新闻详情
export const queryCowDailyPosterDetails = (data = {}) => post(api, data) 


